module.exports = __webpack_public_path__ + "media/lib/components/Icon/check-e94178223b4c0c162b14ac05e4f13ea1.svg";